import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Stack, Dropdown } from '@bingads-webui-react/fabric-control';
import { DatePickerReact } from './date-picker-react';

function getStyles() {
  return {
    inputClassName: {
      width: 'auto !important',
    },
  };
}

function DateTimePicker(props) {
  const {
    i18n,
    classes,
    onDateChange,
    selectedDate,
    onTimeChange,
    selectedHour,
    hideTitle,
    minDate,
    maxDate,
    datePickerId,
    timePickerId,
  } = props;

  const options = _.range(24).map(hour =>
    i18n.formatDate(new Date(2021, 1, 1, hour, 0), {
      skeleton: 'h',
    })).map((value, index) => ({ key: index.toString(), text: value }));

  const onChange = useCallback((_event, option) => {
    onTimeChange(option);
  }, [onTimeChange]);

  return (
    <Stack
      horizontal
      tokens={{ childrenGap: 10 }}
    >
      <DatePickerReact
        i18n={i18n}
        onDateChange={onDateChange}
        selectedDate={selectedDate}
        inputClassName={classes.inputClassName}
        hideTitle={hideTitle}
        minDate={minDate}
        maxDate={maxDate}
        id={datePickerId}
      />
      <div id={timePickerId || 'TimePicker'}>
        {hideTitle ? null : <div>{i18n.getString(_TL_('Time'))}</div>}
        <Dropdown
          className="start-time-dropdown"
          placeholder={i18n.getString(_TL_('Select time'))}
          dropdownWidth="auto"
          selectedKey={selectedHour}
          onChange={onChange}
          options={options}
          ariaLabel={i18n.getString(_TL_('Select time'))}
        />
      </div>
    </Stack>
  );
}

DateTimePicker.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    inputClassName: PropTypes.string,
  }).isRequired,
  onDateChange: PropTypes.func.isRequired,
  selectedDate: PropTypes.number,
  onTimeChange: PropTypes.func.isRequired,
  selectedHour: PropTypes.string,
  hideTitle: PropTypes.bool,
  minDate: PropTypes.shape(),
  maxDate: PropTypes.shape(),
  datePickerId: PropTypes.string,
  timePickerId: PropTypes.string,
};

DateTimePicker.defaultProps = {
  minDate: null,
  maxDate: null,
  selectedHour: null,
  selectedDate: null,
  hideTitle: false,
  datePickerId: undefined,
  timePickerId: undefined,
};

const Wrapped = withDefaultStyles(DateTimePicker, getStyles);

export { Wrapped as DateTimePicker };
